export const environment = {
    appVersion: require('../../package.json').version,
    azure: {
        app_insights: {
            instrumentation_key: '#{instrumentationKey}#'
        }
    },
    default_device_settings: {
        deactivate_sim_cards: true,
        deconfigure_tracker: true,
        scanFault_codes: true
    },
    oversight_api_key: '#{oversightApiKey}#',
    oversight_x_lt_art: '#{oversightXltArt}#',
    oversight_endpoint: '#{oversightEndPoint}#',
    recycling_api_endpoint: '#{recyclingApiEndPoint}#'
};
